<template>
  <div style="background-color: #f7f7f7" class="non-listed-documents">
    <div v-if="$route.params.region" style="background-color: #020202;">
      <header-navigation></header-navigation>
      <non-listed-header></non-listed-header>
      <a href="#" class="to-top active">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="40"
          height="40"
          viewBox="0 0 24 24"
          border-radius="20%"
          fill="none"
          style="background-color:#0D0A15"
          stroke-width="2"
          stroke-linecap="round"
          stroke="white"
        >
          <path d="M18 15l-6-6-6 6" />
        </svg>
      </a>
    </div>
    <pageloader v-if="pageload" />
    <div v-if="visible" class="container my-4" tabindex="0">
      <!-- @blur="
        hideToolTip();
        changeToolTipHeight();
      " -->
      <div v-if="products.length === 0 && !pageload">
        <h3
          class="d-flex justify-content-center align-items-center"
          style="font-size: 16px; height: 300px;"
        >
          No Products Available.
        </h3>
      </div>
      <div
        v-for="(cat, index) in categories"
        :key="index"
        v-if="
          products.filter((item) => item.category.includes(cat.name)).length
        "
        class="mt-4 products-col"
      >
        <div class="d-flex align-items-center">
          <h3 style="text-transform: capitalize;" class="mt-3 mb-0 fs-4">
            {{ cat.name.split("-").join(" ") }}
          </h3>
          <span class="mt-3 ml-2"
            >({{
              products.filter((item) => item.category.includes(cat.name)).length
            }}
            {{
              products.filter((item) => item.category.includes(cat.name))
                .length > 1
                ? "products"
                : "product"
            }})</span
          >
        </div>
        <div v-if="products.length" class="my-carousel" style="height: 160px;">
          <div
            class="product-col"
            v-for="(slide, index) in products"
            :key="index"
            v-if="slide.category.includes(cat.name)"
            @click="selectSlide(index)"
            :style="{
              'background-color':
                index === selectedIndex ? '#ab0a0a26' : '#ffffff',
            }"
          >
            <div
              class="d-flex"
              style="padding: 20px;"
              @click="
                filterDocuments.length = 0;
                showDocs(slide.slug, slide.id, cat.name);
              "
            >
              <div
                class="col-5 product-img"
                :style="{ backgroundImage: 'url(' + slide.img + ')' }"
              ></div>
              <div class="col-7 product-details">
                <h3 class="product-title">{{ slide.title }}</h3>
                <span
                  class="btn cta-plain text-red icon right-arrow textButtonDark"
                  style="cursor: pointer;"
                  >{{
                    isOpen.id === slide.id && isOpen.show === true
                      ? "Hide Documents"
                      : "Show Documents"
                  }}</span
                >
              </div>
            </div>
          </div>
        </div>
        <div
          v-if="selectedCategory === cat.name && isOpen.show"
          class="container d-flex document-carousel"
          style="background: #ffffff; borderRadius: 6px; padding: 20px; margin: 10px 0; transition: all 0.4s ease 0s;"
          :style="{ 'min-height': tooltipHeight + 'px' }"
        >
          <div v-if="filterDocuments.length === 0" class="w-100">
            <div class="cssload-container">
              <div class="cssload-loading"><i></i><i></i></div>
            </div>
          </div>
          <div
            v-for="(item, index) in filterDocuments"
            :key="index"
            class="d-flex position-relative filter-documents"
          >
            <a
              v-if="item.files.length === 1"
              :href="item.files[0].file"
              style="color: #020202;"
              class="d-flex flex-column justify-content-start align-items-center text-center w-100 p-2"
              target="_blank"
            >
              <strong>
                {{ item.title }}
                <!-- tooltip here -->
              </strong>

              <div
                class="d-flex justify-content-center mt-2 col-10 p-0 mx-auto slick-slider-non-listed"
                style="width: inherit; max-width: 300px;"
              >
                <div class="col-2"></div>
                <div
                  class="d-flex justify-content-center p-0 col-9"
                  style="gap: 10px;"
                >
                  <div
                    class="d-flex flex-column justify-content-start align-items-start"
                  >
                    <span
                      class="mb-1"
                      style="font-size: 14px; font-weight: 600; font-family: 'Plus Jakarta Sans', sans-serif; font-weight: 500; color: #0D0A15;"
                    >
                      <span
                        style="font-weight: 400; font-size: 13px; color: rgb(12 12 12)"
                      >
                        ID
                      </span>
                      {{ getDocumentId(item.files[0].file) }}
                    </span>
                    <span
                      style="font-size: 12px; font-weight: 400; color: #a9a9a9; font-family: 'Plus Jakarta Sans', sans-serif;"
                    >
                      {{ format_date(item.files[0].date) }}
                    </span>
                  </div>

                  <div
                    class="d-flex flex-column justify-content-start align-items-start"
                  >
                    <span
                      class="mb-1"
                      style="font-size: 14px; font-weight: 600; font-family: 'Plus Jakarta Sans', sans-serif; font-weight: 500; color: #0D0A15;"
                      >{{ item.files[0].language }}</span
                    >
                    <span
                      style="font-size: 12px; font-weight: 400; color: #a9a9a9; font-family: 'Plus Jakarta Sans', sans-serif;"
                      >{{ getSize(item.files[0]) }}</span
                    >
                  </div>
                </div>
                <img
                  src="@/assets/images/download-icon.svg"
                  class="d-inline-block align-middle col-2 p-0"
                  style="height: 34px"
                />
              </div>
            </a>
            <a
              class="d-flex flex-column justify-content-center align-items-center text-center w-100"
              style="color: #020202;"
              @click.prevent="showToolTip(item.slug)"
              v-else-if="item.files.length > 1"
            >
              <!-- @focus="showToolTip(item.slug)" -->
              <!-- @blur="
                hideToolTip();
                changeToolTipHeight();
              " -->
              <strong>
                {{ item.title }}
                <!-- tooltip here -->
              </strong>

              <div class="mt-3 pdf-card-row">
                <div class="d-flex col-12">
                  <div class="col-2">
                    <img
                      src="@/assets/images/resmed-tooltip-icon.png"
                      v-tooltip="{
                        content: 'ResMed Internal only',
                        classes: ['tooltipQualityAssistant'],
                      }"
                      v-if="
                        item.availability == 'true' ||
                          item.availability.includes('true')
                      "
                    />
                  </div>
                  <div class="d-flex justify-content-center p-0 col-9">
                    <div
                      class="d-flex flex-column justify-content-between align-items-center"
                    >
                      <span
                        style="color: rgb(176, 37, 67); font-family: 'Plus Jakarta Sans', sans-serif; font-weight: 700"
                        >{{ item.cta }}</span
                      >
                      <span
                        style="font-size: 14px; font-weight: 400; color: rgb(169, 169, 169);font-family: 'Plus Jakarta Sans', sans-serif; font-weight: 500;"
                      >
                        ({{ item.multiple_documents_cta }})
                      </span>
                    </div>
                  </div>
                  <div class="col-2">
                    <img
                      src="@/assets/images/multiple-download-icon.svg"
                      class="d-inline-block align-middle"
                      style="height: 40px"
                    />
                  </div>
                </div>
              </div>
            </a>

            <div
              v-bind:class="{
                tooltip: true,
                visible: isTooltipVisible === item.slug,
              }"
              v-if="
                item.files &&
                  item.files.length > 1 &&
                  isTooltipVisible === item.slug
              "
            >
              <div class="content">
                <ul>
                  <li v-for="singleitem in item.files">
                    <a
                      @click.stop="saveMyDownload(singleitem.file, e)"
                      class="btn cta-plain text-red icon right-arrow textButtonDark"
                      v-bind:href="singleitem.file"
                      target="_blank"
                    >
                      <!-- v-on:click.stop="active = singleitem.title" -->
                      <div class="multicontainer">
                        <div
                          class="d-flex flex-column justify-content-between"
                          style="border-right: 1px solid #d9d9d9; min-width: 82px; margin-right: 10px;"
                        >
                          <span
                            class="my-auto"
                            style="font-size: 14px; font-weight: 600; color: #0D0A15; white-space: break-spaces;"
                            >{{ singleitem.language }}</span
                          >
                        </div>
                        <div class="d-flex flex-column">
                          <span
                            class="mb-1"
                            style="font-size: 13px; font-weight: 600; color: #0D0A15"
                          >
                            <span
                              v-if="getDocumentId(singleitem.file)"
                              style="font-weight: 400; font-size: 13px; color: rgb(12 12 12);"
                              >ID
                            </span>
                            {{ getDocumentId(singleitem.file) }}
                          </span>
                          <div style="color: #a9a9a9">
                            <span style="font-size: 12px; font-weight: 400">{{
                              getSize(singleitem)
                            }}</span
                            >&nbsp;|
                            <span style="font-size: 12px; font-weight: 400">{{
                              format_date(singleitem.date)
                                ? format_date(singleitem.date)
                                : "N/A"
                            }}</span>
                          </div>
                        </div>
                      </div>
                    </a>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div v-else class="container py-4">
      <h3
        class="d-flex justify-content-center align-items-center"
        style="font-size: 16px; height: 300px;"
      >
        Please Login to view the page.
      </h3>
    </div>
    <div v-if="$route.params.region">
      <footer>
        <nav class="company-pages px-3 px-md-0">
          <div class="container">
            <div class="">
              <footer-navigation
                v-bind:category="'quick-links'"
              ></footer-navigation>
            </div>
            <hr class="d-none d-md-block" />

            <div class="row">
              <div class="col-lg-8 my-5 mt-md-0 my-lg-0">
                <footer-navigation
                  v-bind:category="'useful-links'"
                ></footer-navigation>
              </div>

              <div class="col-lg-4">
                <social-media></social-media>
                <div class="copyright-disclaimers d-none d-md-block">
                  <p><span>© ResMed</span> All rights reserved.</p>
                </div>
              </div>
            </div>
          </div>
        </nav>
      </footer>
      <!-- <modal-video></modal-video> -->
    </div>
  </div>
</template>

<script>
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import $ from "jquery";
import "slick-carousel";
import moment from "moment";
import axios from "axios";
import pageloader from "./components/shared-support/pageloader.vue";
import NonListedHeader from "./components/navigation/non-listed-header.vue";

export default {
  name: "NonListedProducts",
  components: { pageloader, NonListedHeader },
  data() {
    return {
      products: [],
      documents: [],
      filterDocuments: [],
      categories: [],
      isOpen: { id: null, show: false },
      selectedItemId: null,
      selectedCategory: null,
      pageload: true,
      metaData: {},
      documentsload: false,
      selectedIndex: -1,
      isTooltipVisible: -1,
      tooltipHeight: 164,
      tooltipUpdated: false,
    };
  },
  mounted() {
    this.visible ? this.fetchProducts() : (this.pageload = false);
  },
  beforeDestroy() {
    $(".my-carousel").slick("unslick");
  },
  computed: {
    visible() {
      const email = this.$cookies.get("rocEmail");
      const role = this.$cookies.get("role");
      const categoryCookie = $cookies.get("categories");

      try {
        if (
          (categoryCookie == "" || categoryCookie == null) &&
          (role != "" || role != null)
        ) {
          this.$cookies.set(
            "categories",
            role && role.replace(/approved/g, "approve"),
            null,
            "/",
            window.location.hostname.includes(".resmed.com")
              ? ".resmed.com"
              : "localhost"
          );
        }
      } catch (error) {
        console.log(error);
      }

      if (email && email.toLowerCase().includes("@resmed.")) {
        return true;
      }
      if (role && role.includes("technical_approved")) {
        return true;
      }
      return false;
    },
  },
  methods: {
    selectSlide(index) {
      this.selectedIndex !== index
        ? (this.selectedIndex = index)
        : (this.selectedIndex = -1);
    },
    async fetchProducts() {
      // check for user login
      const useremail = this.$cookies.get("rocEmail");
      const usersid = this.$cookies.get("rocSid");
      // const role = this.$cookies.get("role");
      const email = this.$cookies.get("rocEmail");
      const categories = this.$cookies.get("categories");
      const internalUserEmailSuffix = "@resmed.";
      const sleepApproved = categories && categories.includes("sleep_approve");
      const oxygenApproved =
        categories && categories.includes("oxygen_approve");
      const ventilatorApproved =
        categories && categories.includes("ventilator_approve");

      const data = await axios({
        url: `${process.env.VUE_APP_GSSPOD_ENPOINT}/graphql`,
        method: "post",
        headers: {
          "Content-Type": "application/json",
          rocSid: `${usersid}`,
          email: `${useremail}`,
          region: `${this.$route.params.region}`,
        },
        data: {
          query: `
              query {
            getNonListedData(region: "${
              this.$route.params.region
            }", type: "product")
          }
            `,
        },
      });

      const productsArr = [];
      await data.data.data.getNonListedData.data.filter((item) => {
        if (!email.includes(internalUserEmailSuffix)) {
          if (
            categories &&
            (sleepApproved || ventilatorApproved || oxygenApproved)
          ) {
            if (item.category.includes("sleep-devices") && sleepApproved) {
              productsArr.push(item);
            }
            if (item.category.includes("oxygen") && oxygenApproved) {
              productsArr.push(item);
            }
            if (item.category.includes("ventilators") && ventilatorApproved) {
              productsArr.push(item);
            }
          }
        } else {
          productsArr.push(item);
        }
        return null;
      });
      this.products = productsArr;
      this.categories = data.data.data.getNonListedData.categories;

      this.$nextTick(() => {
        $(".my-carousel").slick({
          dots: false,
          arrows: true,
          infinite: false,
          speed: 300,
          slidesToShow: 3.5,
          slidesToScroll: 1,
          prevArrow: '<button class="slick-prev slick-arrow"></button>',
          nextArrow: '<button class="slick-next slick-arrow"></button>',
          responsive: [
            {
              breakpoint: 1024,
              settings: {
                slidesToShow: 2,
                slidesToScroll: 1,
                infinite: true,
                dots: true,
              },
            },
            {
              breakpoint: 600,
              settings: {
                slidesToShow: 1,
                slidesToScroll: 1,
              },
            },
            {
              breakpoint: 480,
              settings: {
                slidesToShow: 1,
                slidesToScroll: 1,
              },
            },
          ],
        });
      });
      this.pageload = false;
    },

    async fetchDocuments(slug) {
      this.tooltipHeight = 140;
      // this.documentsload = true;
      const useremail = this.$cookies.get("rocEmail");
      const usersid = this.$cookies.get("rocSid");
      const data = await axios({
        url: `${process.env.VUE_APP_GSSPOD_ENPOINT}/graphql`,
        method: "post",
        headers: {
          "Content-Type": "application/json",
          rocSid: `${usersid}`,
          email: `${useremail}`,
          region: `${this.$route.params.region}`,
        },
        data: {
          query: `
              query {
            getNonListedData(region: "${
              this.$route.params.region
            }", type: "manual", productSlug: "${slug}" )
          }
            `,
        },
      });
      this.documents = await data.data.data.getNonListedData.data;

      let newSection = [];

      // check for user login
      const role = this.$cookies.get("role");
      const email = this.$cookies.get("rocEmail");
      const categories = this.$cookies.get("categories");
      const sleepApproved = categories && categories.includes("sleep_approve");
      const oxygenApproved =
        categories && categories.includes("oxygen_approve");
      const ventilatorApproved =
        categories && categories.includes("ventilator_approve");

      if (this.documents.length) {
        this.documents.map(async (item) => {
          if (!item.files || !item.files.length) {
            return;
          }

          const doc = await item.files[0].file;

          if (doc) {
            console.log(item);
            if (doc.includes("/secure")) {
              if (
                doc.includes("/secure/tsp") &&
                email &&
                email.includes(internalUserEmailSuffix) &&
                role &&
                role.includes("technical_approved")
              ) {
                newSection.push(item);
              }

              // if (
              //   doc.includes("/secure/tsp") &&
              //   email &&
              //   !email.includes("resmed.com") &&
              //   role &&
              //   role.includes("technical_approved") &&
              //   sleepApproved &&
              //   item.category.includes('sleep-devices') &&
              //   item.availability == "false"
              // ) {
              //   newSection.push(item);
              // }
              if (
                doc.includes("/secure/tsp") &&
                email &&
                !email.includes(internalUserEmailSuffix) &&
                role &&
                role.includes("technical_approved") &&
                sleepApproved &&
                item.category.includes("sleep-devices") &&
                // (oxygenApproved ||
                //   !oxygenApproved ||
                //   ventilatorApproved ||
                //   !ventilatorApproved) &&
                item.availability == "false"
              ) {
                newSection.push(item);
              }
              if (
                doc.includes("/secure/tsp") &&
                email &&
                !email.includes(internalUserEmailSuffix) &&
                role &&
                role.includes("technical_approved") &&
                oxygenApproved &&
                item.category.includes("oxygen") &&
                // (sleepApproved ||
                //   !sleepApproved ||
                //   ventilatorApproved ||
                //   !ventilatorApproved) &&
                item.availability == "false"
              ) {
                newSection.push(item);
              }
              if (
                doc.includes("/secure/tsp") &&
                email &&
                !email.includes(internalUserEmailSuffix) &&
                role &&
                role.includes("technical_approved") &&
                ventilatorApproved &&
                item.category.includes("ventilators") &&
                // (sleepApproved ||
                //   !sleepApproved ||
                //   oxygenApproved ||
                //   !oxygenApproved) &&
                item.availability == "false"
              ) {
                newSection.push(item);
              }
              if (!doc.includes("/secure/tsp")) {
                newSection.push(item);
              }
            } else {
              newSection.push(item);
            }
          }

          this.filterDocuments = newSection;
          // this.$nextTick(() => (this.documentsload = false));
        });
      }

      this.$nextTick(async () => {
        let docLength = this.filterDocuments.length > 3 ? 3 : 1;
        // if (this.filterDocuments.length > 3) {
        // $(".document-carousel").removeClass("grid-documents");
        $(document).ready(function() {
          $(".document-carousel").slick({
            dots: true,
            arrows: false,
            infinite: false,
            speed: 300,
            slidesToShow: docLength,
            slidesToScroll: 1,
            prevArrow: '<button class="slick-prev slick-arrow"></button>',
            nextArrow: '<button class="slick-next slick-arrow"></button>',
            responsive: [
              {
                breakpoint: 1024,
                settings: {
                  slidesToShow: 2,
                  slidesToScroll: 1,
                  infinite: true,
                  dots: true,
                },
              },
              {
                breakpoint: 600,
                settings: {
                  slidesToShow: 1,
                  slidesToScroll: 1,
                },
              },
              {
                breakpoint: 480,
                settings: {
                  slidesToShow: 1,
                  slidesToScroll: 1,
                },
              },
            ],
          });
        });
        // } else if (
        //   this.filterDocuments.length < 3 &&
        //   this.filterDocuments.length !== 0
        // ) {
        //   $(".document-carousel").hasClass("slick-initialized")
        //     ? $(".document-carousel").slick("unslick")
        //     : null;
        //   $(".document-carousel").addClass("grid-documents");
        // }
      });
    },

    async showDocs(slug, id, category) {
      this.filterDocuments.length = 0;
      // this.isOpen.show = this.selectedItemId === id ? !this.isOpen.show : true;
      if (this.selectedItemId === id) {
        this.isOpen.show = !this.isOpen.show;
      } else if (document.querySelector(".document-carousel")) {
        //
        this.isOpen.show = false;
        setTimeout(() => {
          this.isOpen.show = true;
          this.hideToolTip();
          this.isTooltipVisible = -1;
        }, 0);
      } else {
        this.isOpen.show = true;
      }
      this.selectedItemId = id;
      this.isOpen.id = id;
      this.selectedCategory = category;
      const data = await this.fetchDocuments(slug);
      return data;
    },

    async showToolTip(index) {
      this.$nextTick(() => {
        const div = document.querySelector(".tooltip.visible");
        if (div && this.isTooltipVisible != -1) {
          this.isTooltipVisible = -1;
          this.tooltipUpdated = true;
          this.tooltipHeight = 164;
        } else if (div) {
          this.tooltipHeight = div.offsetHeight + 164;
          this.isTooltipVisible = index;
          this.tooltipUpdated = true;
        } else {
          this.isTooltipVisible = index;
          setTimeout(() => {
            const div = document.querySelector(".tooltip.visible");
            if (div) {
              this.tooltipHeight = div.offsetHeight + 164;
              this.isTooltipVisible = index;
            } else {
              console.log("Tooltip not yet visible");
            }
          }, 100);
        }
      });
    },
    hideToolTip() {
      this.isTooltipVisible = -1;
      // this.tooltipHeight = 164;
    },
    changeToolTipHeight() {
      this.tooltipHeight = 164;
    },

    getSize(item) {
      if (item && item.size) {
        console.log(
          "file",
          item.size,
          `${(item.size / (1024 * 1024)).toFixed(2)} MB`
        );
        return `${(item.size / (1024 * 1024)).toFixed(2)} MB`;
      } else {
        return "NA";
      }
    },

    getDocumentId(url) {
      try {
        let allItems = url.split("/");
        let id = allItems[allItems.length - 1]
          .replace(".pdf", "")
          .split("_")
          .filter((item) => (item.length > 3 ? Number(item) : null));
        return id.length ? id[0] : "NA";
      } catch (error) {
        console.log(error);
      }
    },

    format_date(item) {
      if (item) {
        return moment(String(item)).format("MMM D, YYYY");
      }
    },

    getDocumentHref(url, locked) {
      // let role = $cookies.get("role");
      // console.log("HREF", locked);
      if (locked === "false" || locked === "APPROVED" || locked === "true") {
        return url;
      } else {
        // let regionCode = $cookies.get("RegionCode");
        if (locked === "NO_SESSION") {
          // console.log("HREF", "No session");
          return `${process.env.VUE_APP_ROCUI_ENDPOINT}/${
            this.$route.params.region
          }/signin?product-support&redirect_to=${this.$route.path}`;
        }
        this.invalidAccess = true;
        return "javascript:void(0)";
      }
    },

    createDownloadPayload(url, email) {
      const cookieUserId = this.$cookies.get("userId");
      return {
        email,
        materialPath: url,
        materialType: url.slice(-3),
        userId: cookieUserId || this.$store.state.userId,
        country: this.$store.state.country,
        region: this.$route.params.region || this.$cookies.get("RegionCode") || "",
      };
    },

    existingGraphQLRequest(payload, rocSid) {
      const graphqlPayload = { ...payload };
      delete graphqlPayload.region;
      return axios({
        url: `${process.env.VUE_APP_ROC_ENPOINT}/graphql`,
        method: "post",
        headers: {
          "Content-Type": "application/json",
          x_api_key: "121",
          session: rocSid,
        },
        data: {
          query: `mutation CreateDownloadMaterials($input: [DownloadMaterialInput!]!) {
            createDownloadMaterials(input: $input) {
              id
            }
          }`,
          variables: {
            input: [graphqlPayload],
          },
        },
      });
    },

    secureDocumentRequest(payload, rocSid) {
      return axios({
        url: `${process.env.VUE_APP_GPSPOD_ENDPOINT}/db/secure-document`,
        method: "post",
        headers: {
          "Content-Type": "application/json",
          session: rocSid,
          rocSid,
        },
        data: [payload],
      });
    },

    async executeDownloadTrackingRequests(url, email) {
      const rocSid = this.$cookies.get("rocSid");
      const payload = this.createDownloadPayload(url, email);

      const [graphqlResult, secureDocumentResult] = await Promise.allSettled([
        this.existingGraphQLRequest(payload, rocSid),
        this.secureDocumentRequest(payload, rocSid),
      ]);

      const result = {
        graphql: {
          success: graphqlResult.status === "fulfilled",
          data:
            graphqlResult.status === "fulfilled"
              ? graphqlResult.value.data
              : null,
          error:
            graphqlResult.status === "rejected"
              ? graphqlResult.reason
              : null,
        },
        secureDocument: {
          success: secureDocumentResult.status === "fulfilled",
          data:
            secureDocumentResult.status === "fulfilled"
              ? secureDocumentResult.value.data
              : null,
          error:
            secureDocumentResult.status === "rejected"
              ? secureDocumentResult.reason
              : null,
        },
      };

      console.log("Download tracking responses:", result);
      return result;
    },

    saveMyDownload(url, e) {
      e.preventDefault();
      // console.log("362",url);
      if (url.includes("/secure")) {
        // console.log("364",url);
        // Check access => if no access then do not proceed
        if (this.getDocumentHref(url, "APPROVED") === "javascript:void(0)") {
          return;
        }
        // Call API
        let oktaEndpoint = $cookies.get("rocServ");
        let oktaEmail = $cookies.get("rocEmail");
        let oktaSid = $cookies.get("rocSid");
        let oktaRegion = $cookies.get("RegionCode");
        // if (!oktaEndpoint || !oktaEmail || !oktaSid || !oktaRegion) {
        //   this.removeAllCookies();
        //   window.open(url, "_blank").focus();

        //   return;
        // }
        // console.log("383",oktaEndpoint)

        axios({
          url: `${process.env.VUE_APP_ROC_ENPOINT}/graphql`,
          method: "post",
          headers: {
            "Content-Type": "application/json",
            x_api_key: "121",
            session: oktaSid,
          },
          data: {
            query: `mutation CreateDownloadMaterials($input: [DownloadMaterialInput!]!) {
            createDownloadMaterials(input: $input) {
              id
            }
          }`,
            variables: {
              input: [
                {
                  email: oktaEmail,
                  materialPath: url,
                  materialType: url.slice(-3),
                  userId: this.$store.state.userId,
                  country: this.$store.state.country,
                },
              ],
            },
          },
        })
          .then(() => {
            window.open(url, "_blank").focus();
          })
          .catch(() => {
            // this.removeAllCookies();
            window.location.reload();
          });
      } else {
        // console.log("405",url);
        window.open(url, "_blank").focus();
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.product-img {
  background-size: contain;
  background-repeat: no-repeat;
  background-position: center;
  max-height: 125px;
  min-width: 100px;
}

.product-title {
  margin-bottom: 1rem;
  font-size: 1.12rem;
}

.products-col {
  margin: auto;
  width: 100%;

  @media (max-width: 768px) {
    width: 92% !important;
  }
}

.product-col {
  background-color: #ffffff;
  height: 140px;
  border-radius: 6px;
  width: 94% !important;
  cursor: pointer;
  display: flex !important;
  justify-content: center;
  align-items: center;

  @media (max-width: 768px) {
    width: 100% !important;
  }
}

.document-carousel {
  padding: 20px;

  @media (max-width: 768px) {
    padding: 14px 12px;
  }
}

.slick-slide {
  width: calc(100% / 4 - 20px) !important;
  margin-right: 20px !important;
}

.product-details {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  height: 104px;
  width: 100%;
}

.filter-documents {
  cursor: pointer;
}
</style>

<style lang="scss" scoped>
@import "./css/abstracts/path";
@import "./css/abstracts/colors";
@import "./css/base/typography";
@import "./css/base/utilities";
.tooltip {
  animation: fade-in 0.5s ease;

  z-index: 99;
  position: absolute;
  min-width: 275px;
  min-height: 100px;

  // top: 38px;
  left: 50%;
  transform: translateX(-50%);

  display: none;
  flex-direction: column;

  &:after {
    $size: 0.75rem;
    @include caret($size);
    border-bottom: $size solid $cc-resmed-white;

    left: 50%;
    transform: translateX(-50%);
    top: -1.5rem;
  }

  > .content {
    background-color: $cc-resmed-white;
    box-shadow: 0 0rem 12px 6px rgba(0, 0, 0, 0.125);

    flex-grow: 1;
    // padding: 1.5rem 2rem 1rem 2rem;
    padding: 1.5rem;
    border-radius: 6px;

    text-align: left;

    @media (max-width: 768px) {
      padding: 1rem;
    }

    ul {
      list-style: none;

      li:not(:last-child) {
        // margin-bottom: 1rem;
        margin-bottom: 12px;
        // padding-bottom: 1rem;
        padding-bottom: 12px;
        border-bottom: 1px solid $cc-resmed-bg-grey-1;
      }

      a {
        display: block;
      }

      span {
        @extend %body-small;
        color: $cc-resmed-grey-85;
      }
    }
  }
}

.visible {
  display: flex;
}

.tooltip.visible {
  position: absolute;
  margin: 20px;
  top: 100px;
  left: 50%;
  transform: translate(-50%, -10%);

  @media (max-width: 768px) {
    margin: 6px 0;
  }
}

a.btn.cta-plain.text-red.icon a {
  color: #0c0c0c;
}

a.btn.cta-plain.text-red.icon div {
  margin-right: 5px;
}

.pdf-card-row {
  display: flex;
  justify-content: space-around;
  align-items: center;
}
.multicontainer {
  display: grid;
  grid-template-columns: 45% 55%;
  gap: 10px;
}

.grid-documents {
  display: grid !important;
  justify-content: start;
  align-items: baseline;
  grid-template-columns: 30% 30% 30%;
}

.cssload-container {
  display: flex;
  align-items: center;
  margin: auto;
  width: 97px;
  height: 140px;
}

.cssload-loading i {
  width: 49px;
  height: 49px;
  display: inline-block;
  background-color: #dd2726;
  border-radius: 50%;
}

.cssload-loading i:nth-child(1) {
  animation: cssload-loading-ani1 1.15s ease-in-out infinite;
  -o-animation: cssload-loading-ani1 1.15s ease-in-out infinite;
  -ms-animation: cssload-loading-ani1 1.15s ease-in-out infinite;
  -webkit-animation: cssload-loading-ani1 1.15s ease-in-out infinite;
  -moz-animation: cssload-loading-ani1 1.15s ease-in-out infinite;
}

.cssload-loading i:nth-child(2) {
  background-color: #1788c3;
  margin-left: -10px;
  animation: cssload-loading-ani1 1.15s ease-in-out 0.58s infinite;
  -o-animation: cssload-loading-ani1 1.15s ease-in-out 0.58s infinite;
  -ms-animation: cssload-loading-ani1 1.15s ease-in-out 0.58s infinite;
  -webkit-animation: cssload-loading-ani1 1.15s ease-in-out 0.58s infinite;
  -moz-animation: cssload-loading-ani1 1.15s ease-in-out 0.58s infinite;
}

/** new spinner icons8.com End **/
/** new spinner icons8.com end **/
@keyframes cssload-loading-ani1 {
  70% {
    transform: scale(0.5);
  }
}

@-o-keyframes cssload-loading-ani1 {
  70% {
    -o-transform: scale(0.5);
  }
}

@-ms-keyframes cssload-loading-ani1 {
  70% {
    -ms-transform: scale(0.5);
  }
}

@-webkit-keyframes cssload-loading-ani1 {
  70% {
    -webkit-transform: scale(0.5);
  }
}

@-moz-keyframes cssload-loading-ani1 {
  70% {
    -moz-transform: scale(0.5);
  }
}
</style>